import { Component, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, ChangeDetectorRef, Renderer2, ElementRef } from '@angular/core';
import * as _ from 'lodash';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { v_InvoiceLineItemBus } from '@app/cp/shared/models/v_InvoiceLineItemBus';
import { InvoiceService } from '@app/cp/shared/services/invoice.service';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { InvoiceLinesBus } from '@app/cp/shared/models/InvoiceLinesBus';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { InventoryService } from '@app/cp/shared/services/inventory.service';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { InvoiceMessageInfo } from '@app/cp/shared/models/InvoiceMessageInfo';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { Subscription, fromEvent, Subject } from 'rxjs';
import { tap, take, takeUntil } from 'rxjs/operators';
import { NgZone } from '@angular/core';
import { RowClassArgs, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { InvoiceBus } from '@app/cp/shared/models/InvoiceBus';
import { ColumnComponent, ExcelExportData } from '@progress/kendo-angular-excel-export';
import { GItem } from '@app/cp/shared/models/GItem';
import { BaseGridEditInvLinesComponent } from '@app/cp/shared/base-components/base-grid-edit-invlines.component';
import { MSFilterClass } from '@app/cp/shared/classes/filters/MSFilterClass';
import { MessageType } from '../../shared/enums/MessageType';
import { process, aggregateBy, filterBy} from '@progress/kendo-data-query';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { ConfirmOutput } from '../../shared/models/ConfirmOutput';
import { CPDialogResult } from '../../shared/enums/CPDialogResult';
import { ContextMenuComponent } from '@progress/kendo-angular-menu';
import { environment } from '../../../../environments/environment';
import { InvoiceLineItemsHistoryComponent } from './invoice-lineitems-history/invoice-lineitems-history.component';
import { InvoiceAllHistoryComponent } from './invoice-all-history/invoice-all-history.component';
import { CRUDActions } from '../../shared/enums/CRUDActions';
import { ConfirmDialogComponent } from '../../shared/components/confirm-dialog/confirm-dialog.component';
import { FeatureFlagService } from '../../shared/services/feature-flag.service';
import { UseFeatureFlagSet, IFeatureFlagSet } from '@app/cp/shared/decorators/featureflags/featureflagset-decorator';
import { Message } from '@app/cp/shared/models/message';

@UseFeatureFlagSet()
@Component({
    selector: 'invoice-lineitems',
    templateUrl: './invoice-lineitems.component.html',
    styleUrls: ['./invoice-lineitems.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class InvoiceLineItemsComponent extends BaseGridEditInvLinesComponent<v_InvoiceLineItemBus, null, InvoiceService, InvoiceBus> { // CPWorkOrderDetailComponent>  {
    compFeatureFlagSet: IFeatureFlagSet = this as any;
    inventoryLocationFC: MSFilterClass = new MSFilterClass("inventoryLocationId");
    private destroy$ = new Subject();
    filteredData: any[];
    exportFilteredData: any[];
    private insertMode: boolean = false;
    @Input() canEditInvoiceCost: boolean = false;
    @Output() showDispatch: EventEmitter<any> = new EventEmitter<any>();
    @Input() ShowDispatchPopup: boolean = false;
    @Output() showQuote: EventEmitter<any> = new EventEmitter<any>();
    @Input() ShowQuotePopup: boolean = false;
    @Input() DontRequireChangeCode: boolean = false;
    @Input() avalaraTaxStatus: string = "";
    @Input() canRecalculate: boolean = false;

    @Input() dispatchChanged: boolean = false;
    @Input() isWarranty: any;
    public static virtualizationSettings = { itemHeight: 30, pageSize: 100 };
    @Output() recalculate: EventEmitter<any> = new EventEmitter<any>();
    laborInventoryLocationIds: string[];
    divisionInventoryLocationId: string = "";
    depEnv: string;
    @ViewChild('menu') protected menu: ContextMenuComponent;
    @ViewChild('target') public menuEl: ElementRef;
    @ViewChild('LineItemsHistory') public invoiceLineItemsHistoryComponent: InvoiceLineItemsHistoryComponent;
    @ViewChild('AllHistory') public invoiceAllHistoryComponent: InvoiceAllHistoryComponent;
    @ViewChild('cnfDialogRecalculate') protected cnfDialogRecalculate: ConfirmDialogComponent;
    #LineItemsHistory
    public menuLI: any[] = [
        {
            text: "Copy Summary to Clipboard"
        },
        {
            text: "Copy Description to Clipboard"
        },
    ];

    rowLine: number;
    get DispatchPopupText(): string {
        return this.isConstruction ? "Job" : "Dispatch";
    }
    get ARAutomation(): boolean {
        let hasArAutomation: boolean = false;

        if (this.hasReferenceData) {
            hasArAutomation = this.referenceData.ARInvoiceCreation == 1 && !this.isConstruction ? true : false;
        }
        return hasArAutomation;
    }
    get ARInvocieSave(): number {
        let _ArInvoiceSave: number = 0;

        if (this.hasReferenceData) {
            _ArInvoiceSave = this.referenceData.appSettings.ARInvoiceSave == "1" && !this.isConstruction ? 1 : 0;
        }
        return _ArInvoiceSave;
    }
    public setDataLoading(value) {

        this.dataLoading = value;
    }
    get requireChangeCode(): boolean {
        let ret = false;
        if (this.ARAutomation && !this.DontRequireChangeCode) {
            ret = true;
        }
        return ret;
    }
    get showInvoiceLineCost(): boolean {
        let show: boolean = true;
        //if (this.ARAutomation && !this.rights.InvoiceLineCost) {
        //    show = false;
        //}
        return show;
    }
    //get showChangeCode(): boolean {
    //    return this.isEditing || CommonFunctions.hasGuidValue
    //}
    constructor(globals: GlobalsService, featureFlagService: FeatureFlagService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: InvoiceService, svc_inv: InventoryService, svc_dqoi: DQOIService, private zone: NgZone) {
        super(globals, renderer, cd, svc_inv, svc_dqoi, featureFlagService);
        this.depEnv = environment.deployment;
        this.svc_data = svc_data;
        this.className = "v_InvoiceLineItemBus";
        this.appCode = "InvoiceLines";
        this.subscribeToKeyPress = true;
        this.aggregates = [
            { field: 'amount', aggregate: 'sum' },
            { field: 'tax', aggregate: 'sum' },
            { field: 'totalCost', aggregate: 'sum' }];

        this.allData = this.allData.bind(this);
    }
    showDialogRecalculate() {

        this.cnfDialogRecalculate.show("Do you want to Recalculate Line Items", CRUDActions.Update, null, "Recalculate Line Items", null);
    }
    confirmDialogRecalculate(data: ConfirmOutput) {
;
        if (data.dialogResult === CPDialogResult.ok) {
            for (let e of this.gridData) {
                if (!e.isAdded) {
                    this.deletedItems.push({ description: this.appCode, value: e.CID(), category: null, "reference": null, canSelect: true });
                }
            }
            this.dataLoading = true;
             this.recalculate.emit();
        }

    }

    markupCostAlert(dataItem: any) {
        //return false for now until business can determine if MU cost CAN be lower
        return false;

        // If markupCost or cost is missing, don't add the class
        if (
            dataItem &&
            typeof dataItem.markupCost === 'number' &&
            typeof dataItem.cost === 'number'
        ) {
            if (dataItem.markupCost < dataItem.cost) {
                return true;
            }
        }
        return false;
    };

    createForm() {
        this.columnFocusAdder = 1;
        this.editForm = new UntypedFormGroup({
            'invoiceLineId': new UntypedFormControl(),
            'invoiceId': new UntypedFormControl(),
            'sortOrder': new UntypedFormControl(),
            'quantity': new UntypedFormControl(),
            'cost': new UntypedFormControl(),
            'markup': new UntypedFormControl(),
            'markupPercent': new UntypedFormControl(),
            'price': new UntypedFormControl(),
            'isTaxable': new UntypedFormControl(),
            'isPrintable': new UntypedFormControl(),
            'invoiceLineDesc': new UntypedFormControl(),
            'inventoryNumber': new UntypedFormControl('', Validators.required),
            'isPart': new UntypedFormControl(),
            'hourlyRate': new UntypedFormControl(),
            'overheadRate': new UntypedFormControl(),
            'overheadPercent': new UntypedFormControl(),
            'amount': new UntypedFormControl(),
            'markupCost': new UntypedFormControl(),
            'fullDescription': new UntypedFormControl(),
            'tax': new UntypedFormControl(),
            'sageDt': new UntypedFormControl(),
            'sageCostDt': new UntypedFormControl(),
            'inventoryBillingCodeId': new UntypedFormControl(),
            'inventoryLocationId': new UntypedFormControl('', Validators.required),
            'dispatchId': new UntypedFormControl('', this.showDispatchNumber ? Validators.required : Validators.nullValidator),
            'billingTypeId': new UntypedFormControl(),
            'personId': new UntypedFormControl(),
            'invoiceNumber': new UntypedFormControl(),
            'resource': new UntypedFormControl(),
            'warehouse': new UntypedFormControl(),
            'totalCost': new UntypedFormControl(),
            'billingTypeName': new UntypedFormControl(),
            'isLabor': new UntypedFormControl(),
            'insertDt': new UntypedFormControl(),
            'insertUserId': new UntypedFormControl(),
            'updateDt': new UntypedFormControl(),
            'updateUserId': new UntypedFormControl(),
            'dispatchNumber': new UntypedFormControl(),
            'inventoryFromCode': new UntypedFormControl(),
            'excessInventoryLocationToId': new UntypedFormControl(),
            'originalQuantity': new UntypedFormControl(),
            'warehouseName': new UntypedFormControl(),
            'changeCodeId': new UntypedFormControl(),
            'origin': new UntypedFormControl(),
            'isRefrigerant': new UntypedFormControl(),
            'isNonInvPart': new UntypedFormControl(),
            'avalaraTaxCalculated': new UntypedFormControl(),
            'isTool': new UntypedFormControl(),
            'isConsumable' : new UntypedFormControl()
        });
    }
    invLocCBOChanged(e: any) {
        this.editForm.patchValue({
            inventoryLocationId: e.value,
            warehouseName: e.description,

        });
    }
    setForm() {
        this.editForm.patchValue({
            invoiceLineId: this.selectedData.invoiceLineId,
            sortOrder: this.selectedData.sortOrder,
            quantity: this.selectedData.quantity,
            cost: this.selectedData.cost,
            markup: this.selectedData.markup,
            markupPercent: this.selectedData.markup * 100,
            price: this.selectedData.price,
            isTaxable: this.selectedData.isTaxable,
            isPrintable: this.selectedData.isPrintable,
            invoiceLineDesc: this.selectedData.invoiceLineDesc,
            inventoryNumber: this.selectedData.inventoryNumber,
            isPart: this.selectedData.isPart,
            hourlyRate: this.selectedData.hourlyRate,
            overheadRate: this.selectedData.overheadRate,
            overheadPercent: this.selectedData.overheadPercent,
            amount: this.selectedData.amount,
            markupCost: this.selectedData.markupCost,
            fullDescription: this.selectedData.fullDescription,
            tax: this.selectedData.tax,
            sageDt: this.selectedData.sageDt,
            sageCostDt: this.selectedData.sageCostDt,
            invoiceId: this.selectedData.invoiceId,
            inventoryBillingCodeId: this.selectedData.inventoryBillingCodeId,
            inventoryLocationId: this.selectedData.inventoryLocationId,
            dispatchId: this.selectedData.dispatchId,
            billingTypeId: this.selectedData.billingTypeId,
            personId: this.selectedData.personId,
            invoiceNumber: this.selectedData.invoiceNumber,
            resource: this.selectedData.resource,
            warehouse: this.selectedData.warehouse,
            totalCost: this.selectedData.totalCost,
            billingTypeName: this.selectedData.billingTypeName,
            isLabor: this.selectedData.isLabor,
            insertDt: this.selectedData.insertDt,
            insertUserId: this.selectedData.insertUserId,
            updateDt: this.selectedData.updateDt,
            updateUserId: this.selectedData.updateUserId,
            dispatchNumber: this.selectedData.dispatchNumber,
            inventoryFromCode: this.selectedData.inventoryFromCode,
            originalQuantity: this.selectedData.originalQuantity,
            changeCodeId: this.selectedData.changeCodeId,
            warehouseName: this.selectedData.warehouseName,
            origin: this.selectedData.origin,
            isRefrigerant: this.selectedData.isRefrigerant,
            isNonInvPart: this.selectedData.isNonInvPart,
            avalaraTaxCalculated: this.selectedData.avalaraTaxCalculated,
            relatedJobTypeId: this.selectedData.relatedJobTypeId,
            isTool: this.selectedData.isTool,
            isConsumable: this.selectedData.isConsumable
        });

        this.setRequired();
        this.dataStateChange(null);
    }
    public setRequired(isPart = false) {

        if (this.selectedData.isConsumable || this.selectedData.isTool) {
            this.editForm.controls['inventoryLocationId'].clearValidators();
            this.editForm.controls['inventoryLocationId'].updateValueAndValidity();
        } else {
            if (isPart || this.editForm.get('isPart').value ) {
                this.editForm.get('inventoryLocationId').addValidators(Validators.required);
            } else {
                this.editForm.get('inventoryLocationId').clearValidators();
            }
        }
    }
    get canEditCost(): boolean {
        let can: boolean = true; //false; //[FIX]

        if (this.canEdit && this.selectedData) {
            if (this.canEditInvoiceCost) {
                can = true;
            }
        }

        return can;
    }
    canEditRow(dataItem: v_InvoiceLineItemBus, column: ColumnComponent) {
        let canEdit = super.canEditRow(dataItem);
        if (column.field === "dd") {
            canEdit = false
        }
        else if (dataItem.relatedJobTypeId == CommonValues.RelatedJobType_ChangeOrder) {
            if (column.field === "price") {
                canEdit = false;
            }
        }
        return canEdit;
    }

    setFromReferenceData(data: v_InvoiceLineItemBus) {
        data.resource = this.personName(data.personId);
        data.changeCodeDesc = this.referenceData.getInvLineChangeCode(data.changeCodeId).description;
        return data;
    }

    inventoryLocationList: GItem[];

    public setInventoryLocationList(laborInventoryLocationIds: string[], divisionInventoryLocationId: string) {
        var laborInventoryLocations = [];
        var remainingInventoryLocation = [];
        var divisionInventoryLocation = this.referenceData.warehouses.filter(a => a.value === divisionInventoryLocationId);
        if (laborInventoryLocationIds && laborInventoryLocationIds.length > 0) {
            laborInventoryLocations = this.referenceData.warehouses.filter(a => laborInventoryLocationIds.indexOf(a.value) > - 1);
            remainingInventoryLocation = this.referenceData.warehouses.filter(a => a.value != divisionInventoryLocationId && laborInventoryLocationIds.indexOf(a.value) < 0);
        }
        else {
            remainingInventoryLocation = this.referenceData.warehouses.filter(a => a.value != divisionInventoryLocationId);
        }
        this.inventoryLocationList = [];
        this.inventoryLocationList = this.inventoryLocationList.concat(divisionInventoryLocation);
        this.inventoryLocationList = this.inventoryLocationList.concat(laborInventoryLocations);
        this.inventoryLocationList = this.inventoryLocationList.concat(remainingInventoryLocation);
    }
    public getChanged(): any {
        let arr = super.getChanged().sort((a, b) => (a.sortOrder * 1 > b.sortOrder * 1) ? 1 : -1);
        return arr;
    }
    getChangedObject(dataObj: v_InvoiceLineItemBus) {
        if (dataObj.relatedJobTypeId === CommonValues.RelatedJobType_ChangeOrder) {
            dataObj.price = 0;
        }
        let busObj: InvoiceLinesBus = new InvoiceLinesBus(dataObj);
        busObj.setCommon(this.globals.userId, DateFunctions.getDateNow(), this.globals.companyId, this.globals.personId);
        busObj.setParentId(this._parentId);
        return busObj;
    }
    popupDispatch() {

        this.showDispatch.emit(null);
    }
    popupQuote() {

        this.showQuote.emit(null);
    }
    protected afterSaveCurrent(data: v_InvoiceLineItemBus) {
        if (this.ARAutomation && this.hasParentId && this.ARInvocieSave == 1) {
            this.sendParentMessage(MessageType.saveParent);
        }
    }
    saveIndividual(dataObj: v_InvoiceLineItemBus): Promise<BaseMessageInfo> {
        let busObj: InvoiceLinesBus = this.getChangedObject(dataObj);
        var isAdded = busObj.isAdded;
        let retInfo: BaseMessageInfo = new BaseMessageInfo();
        return new Promise((resolve, reject) => {
            this.svc_data.saveInvoiceLine(busObj).toPromise().then((info: InvoiceMessageInfo) => {
                console.log("invoiceline-save-ind-as-a: ", dataObj);
                if (!info.saveError) {
                    let newDataObj: v_InvoiceLineItemBus = new v_InvoiceLineItemBus(info.primaryReturnView);
                    console.log("invoiceline-save-ind-as-b: ", newDataObj, info);
                    newDataObj = this.setFromReferenceData(newDataObj);
                    retInfo.primaryReturn = newDataObj;
                    this.notify(this.appCode + " Saved Successfully!");
                }
                else {
                    retInfo.message = "Error Saving"
                    retInfo.saveError = true;
                    this.saveError(null, retInfo.message);
                }
                this.dataLoading = false;
                resolve(retInfo);
            });
        });
    }
    get showDispatchNumber(): boolean {
        return CommonFunctions.hasValue(this.parentObj) ? this.parentObj.showDispatchNumberOnLineItems : false;
    }
    get showQuoteNumber(): boolean {
        return CommonFunctions.hasValue(this.parentObj) ? this.parentObj.showQuoteNumberOnLineItems : false;
    }
    setChangeCodeToNull: boolean = false;
    protected formValueChange() {
        if (this.ARAutomation && !this.dontCalcColumns) {
            if (!this.setChangeCodeToNull) {
                this.editForm.patchValue({
                    changeCodeId: null
                });
                this.setChangeCodeToNull = true;
            }
        }
    }
    customCellClick(col: any) {
        this.formValueChange();
    }
    override ngOnInit() {
        super.ngOnInit();
       // this.setupCheckForm();
    }
    private currentSubscription: Subscription;

    override ngOnDestroy(): void {
        super.ngOnDestroy();
        CommonFunctions.unsubscribe(this.currentSubscription);
    }
    public dataStateChange2(state: DataStateChangeEvent): void {
        this.state = state;

    }
    setInventoryLineDataCustom(info: InvoiceMessageInfo) {
        this.selectedData.invoiceLineDesc = this.editForm.value.invoiceLineDesc;
        this.selectedData.changeCodeId = this.editForm.value.changeCodeId;
        this.selectedData.changeCodeDesc = this.editForm.value.changeCodeDesc;
    }
    descriptionOnlyChanged(): boolean {
        let ret = false;
        if (this.hasEditForm) {
            let keyValues = Object.entries(this.editForm.controls).filter(value => value[1].dirty);
            let keys = keyValues.map(value => value[0]);
            if (CommonFunctions.hasArrayElementValue(keys)) {
                if (keys.length === 1 && keys[0] === "invoiceLineDesc") {
                    ret = true;
                }
                else {
                    ret = false;
                }
            }

        }
        return ret;
    }
    historyList = [];
    openHistory(invoiceId: string, invoiceLineId: string) {
        this.invoiceLineItemsHistoryComponent.show(invoiceId, invoiceLineId);
    }
    openAllHistory() {
        if (this.parentId) {
            this.invoiceAllHistoryComponent.show(this.parentId);
        }
    }

    customCanSaveForm(): boolean {
        let canSave = true;

        return canSave;
    }
    customCannotSaveMessage(): string {
        let msg: string = "";
        if (!this.hasValidTaxCode) {
            msg = "There is a Problem with the TaxCode";
        }
        if (this.hasEditForm) {
            if (this.requireChangeCode && !CommonFunctions.hasGuidValue(this.editForm.value.changeCodeId)) {
                msg = " *Change Code is a REQUIRED Field";
            }
            else {
                if (!CommonFunctions.hasGuidValue(this.editForm.value.inventoryLocationId) && this.editForm.value.isPart) {
                    msg = " *Warehouse is a REQUIRED Field";
                }
                else {
                    for (const field in this.editForm.controls) { // 'field' is a string
                        const control = this.editForm.get(field); // 'control' is a FormControl
                        if (control.invalid) {
                            msg = field + " is invalid";
                            break;
                        }
                    }
                }
            }
        }
        return "Cannot Save " + this.appName + ": " + msg;
    }

    dataStateChange(e: any): void {
        //this.state = state;
        //this.gridDataDD = process(this.gridData, this.state);
        if (this.currentSubscription)
        {
            var subs = this.currentSubscription;
            if (this.destroy$) {
                this.destroy$.next('TODO: BILL LOOK AT THIS');
                this.destroy$.complete();
            }
            this.destroy$ = new Subject();
            this.currentSubscription.unsubscribe();
        }

        this.zone.onStable.pipe(take(1))
            .subscribe(() => this.currentSubscription = this.handleDragAndDrop());

    }

    rowCallback(context: RowClassArgs) {
        if (context.dataItem)
            return {
                dragging: context.dataItem.dragging,
                isDraged: context.dataItem.isDraged,
                inFinance: context.dataItem.inFinance,
                isPrintable: !context.dataItem.inFinance && !context.dataItem.isPrintable
            };
        return {};
    }
    handleDragAndDrop(): Subscription {

        const sub = new Subscription(() => { });

        let draggedItemIndex;
        let dropItemIndex;
        let remoteDropItemIndex;
        let droplocation;
        let overCnt: number = 0;
        var inEditMode = "true";
        if (this.editForm) { inEditMode = "false"; }
        const tableRows = Array.from(document.querySelectorAll('div.invoiceGridDiv > .k-grid tr'));
        tableRows.forEach(itemRow => {
            var item = itemRow.children[1];
            if (item && item.localName == 'td' && item.childNodes.length>2) {
                this.renderer.setAttribute(itemRow, 'draggable', inEditMode);
                const dragStart = fromEvent<DragEvent>(itemRow, 'dragstart');
                const dragOver = fromEvent(itemRow, 'dragover');
                const dragEnd = fromEvent(itemRow, 'dragend');
                const dragLeave = fromEvent(itemRow, 'dragleave');

                sub.add(dragStart.pipe(
                    tap(({ dataTransfer }) => {
                        try {
                        } catch (err) {
                            // IE doesn't support setDragImage
                        }
                        try {
                            // Firefox won't drag without setting data
                        } catch (err) {
                            // IE doesn't support MIME types in setData
                        }
                    })
                ).pipe(takeUntil(this.destroy$)).subscribe(({ target }) => {
                    const cell: HTMLTableCellElement = <HTMLTableCellElement>target;
                    const row: HTMLTableRowElement = <HTMLTableRowElement>target;
                    draggedItemIndex = row.rowIndex;
                    const dataItem = this.gridData[draggedItemIndex];

                }));
                sub.add(dragLeave.pipe(takeUntil(this.destroy$)).subscribe((e: any) => {

                    const cell: HTMLTableCellElement = <HTMLTableCellElement>e.target;
                    const row: HTMLTableRowElement = <HTMLTableRowElement>cell.parentElement;
                    const dropIndex = this.closest(row, this.tableRow).rowIndex;
                    if (remoteDropItemIndex == dropIndex) {
                        remoteDropItemIndex = null;
                        this.rowLine = null;
                    }
                    if (dropItemIndex == dropIndex) { dropItemIndex = null; }

                    if (row.localName == "tr") { row.classList.remove("drover") }

                }));

                sub.add(dragOver.pipe(takeUntil(this.destroy$)).subscribe((e: any) => {
                    const cell: HTMLTableCellElement = <HTMLTableCellElement>e.target;
                    const row: HTMLTableRowElement = <HTMLTableRowElement>cell.parentElement;
                    if (draggedItemIndex >= 0) {
                        if (row.localName == "tr") { row.classList.add("drover") }
                    }
                    if (!draggedItemIndex) {
                    }
                    const dropIndex = this.closest(row, this.tableRow).rowIndex;
                    dropItemIndex = dropIndex;
                    remoteDropItemIndex = dropIndex;
                    this.rowLine = dropIndex;
                    if (draggedItemIndex >= -1 && this.gridData.length + 1 >= draggedItemIndex) {
                        e.preventDefault();
                        const dataItem = this.gridData[draggedItemIndex];
                        dataItem.dragging = false;

                    }
                }));

                sub.add(dragEnd.pipe(takeUntil(this.destroy$)).subscribe((e: any) => {
                    if (typeof dropItemIndex != 'undefined' && dropItemIndex != null) {
                        const cell: HTMLTableCellElement = <HTMLTableCellElement>e.target;
                        const row: HTMLTableRowElement = <HTMLTableRowElement>cell.parentElement;
                        if (cell.localName == "tr") { cell.classList.remove("drover"); cell.classList.add('testclass'); }

                        e.preventDefault();
                        const dataItem = this.gridData.splice(draggedItemIndex, 1)[0];
                        this.zone.run(() => {
                            if (draggedItemIndex < dropItemIndex) {
                                dropItemIndex = dropItemIndex - 1;
                            }
                            this.gridData.splice( dropItemIndex, 0, dataItem )
                        });
                        draggedItemIndex = -1;
                        dataItem.dragging = false;

                        this.dataStateChange(null);
                        this.redoSortOrder();
                       // this.grid.data = this.gridData;
                    }
                    const cell: HTMLTableCellElement = <HTMLTableCellElement>e.target;
                    const row: HTMLTableRowElement = <HTMLTableRowElement>cell.parentElement;

                    if (cell.localName == "tr") { cell.classList.remove("drover"); row.classList.remove("drover"); }
                    if (row.localName == "tr") { row.classList.remove("drover"); }

                    const tableRows = Array.from(document.querySelectorAll('div.invoiceGridDiv > .k-grid tr'));
                    tableRows.forEach(itemRow => {
                        itemRow.classList.remove("drover");
                    });

                }));
            }
        });

        return sub;
    }
    insertRow() {
        if (this.insertMode) return false;
        if (this.rowLine >= 0) {
            this.insertMode = true;
            var inrow = new v_InvoiceLineItemBus();
            this.zone.run(() => {
                this.gridData.splice(this.rowLine, 0, inrow);
            }
            );
        }
        return true;
    }
    updateRow(dataItem: v_InvoiceLineItemBus) {

        if (this.rowLine >= 0) {
            var inrow = new v_InvoiceLineItemBus(dataItem);
            inrow.isDraged = true;
            this.zone.run(() => {
                this.gridData.splice(this.rowLine, 1, inrow);
                this.insertMode = false;
            }
            );
            this.rowLine = null;
            this.dataStateChange(null);
            this.redoSortOrder();
            //this.redoSortOrder();
        }
    }
    public canDrop() {

        if (this.rowLine ) { return true}
        if (this.rowLine==0) { return true }
        return false;

    }
    redoSortOrder() {
        let sort: number = 1;
        this.zone.run(() => {
            for (let e of this.gridData) {
                e.sortOrder = sort++;
                e.isUpdated = true;
            }
        });
        this.recalcSubtotal();
    }

    private invoiceHasUseTax(): boolean {
        if (this.gridData && this.gridData.some(e => e.avalaraTaxTypeId === CommonValues.AvalaraTaxType_UseTax)) {
            return true;
        }
        return false;
    }

    private invoiceHasSalesTax() : boolean {
        if (this.gridData && this.gridData.some(e => e.avalaraTaxTypeId === CommonValues.AvalaraTaxType_SalesTax)) {
            return true;
        }
        return false;
    }

    public recalcSubtotal() {
            var priceSum = 0;
            var totalSum = 0;
        for (let e of this.gridData) {
            if (e.inventoryBillingCodeId == CommonValues.BillingCode_SubTotal) {

                if ((priceSum != e.price) || (totalSum != e.amount)) {
                    e.price = priceSum;
                    e.amount = totalSum;
                    e.isUpdated = true;
                }
                priceSum = 0;
                totalSum = 0;
            }
            else {
                priceSum = priceSum + e.price;
                totalSum = totalSum + e.amount;
            }
        };
    }
    tableRow = node => node.tagName.toLowerCase() === 'tr';
    closest = (node, predicate) => {
        while (node && !predicate(node)) {
            node = node.parentNode;
        }

        return node;
    };

    allowChangePrice(data: v_InvoiceLineItemBus): boolean {
        return data.relatedJobTypeId != CommonValues.RelatedJobType_ChangeOrder ? true : false;
    }
    isChangeOrder(data: v_InvoiceLineItemBus): boolean {
        return data.relatedJobTypeId == CommonValues.RelatedJobType_ChangeOrder ? true : false;
    }

    deleteIndividual(data: v_InvoiceLineItemBus) {
        this.svc_data.deleteInvoiceLine(data.invoiceLineId).subscribe((retData: InvoiceMessageInfo) => {
            if (retData.saveError) {
                this.notify(CommonValues.Message_ErrorDeleting + " - " + retData.message, 'E');
            }
            else {
                this.removeLocal(data);
                this.notify(CommonValues.Message_SuccessfullyDeleted);

            }
        });
    }
    AfterLoad(): void {
        this.dataStateChange(null);
    }
    processGridData() {
        this.exportFilteredData = filterBy(this.filteredData, this.filter);
        if (this.hasGridData) {
            for (let i = 0; i < this.gridData.length; i++) {
                if (!this.gridData[i].resource) {
                    this.gridData[i].resource = this.personName(this.gridData[i].personId);
                }
                if (!this.gridData[i].warehouseName) {
                    this.gridData[i].warehouseName = this.warehouseName(this.gridData[i].inventoryLocationId);

                }
            }
        }
        this.sumAggregates();
        this.AfterLoad();
    }

    public sumAggregates(gridData: v_InvoiceLineItemBus[] = null) {
        if (!CommonFunctions.hasArrayElementValue(gridData)) {
            gridData = this.gridData;
        }
        if (CommonFunctions.hasArrayElementValue(gridData)) {
            var gridDataNoSubTotals = gridData.filter(a=>a.inventoryBillingCodeId != CommonValues.BillingCode_SubTotal)
            this.aggregateResults = aggregateBy(gridDataNoSubTotals, this.aggregates);
            this.sendParentMessageByMessage(new Message({
                messageType: MessageType.aggregateResultsUpdated,
                value: {
                    parentObj: this.parentObj,
                    aggregateResults: this.aggregateResults
                }
            }));
        }
    }
    protected saveLocal(data: v_InvoiceLineItemBus, isNew: boolean) {
        super.saveLocal(data, isNew);
        this.recalcSubtotal();
    }
    protected afterSetInventoryLine() {
        super.afterSetInventoryLine();
        if (this.selectedData.inventoryBillingCodeId == CommonValues.BillingCode_RET) {
            if (this.gridData.length > 0) {
                this.selectedData.dispatchId = this.gridData[0].dispatchId;
                this.selectedData.dispatchNumber = this.gridData[0].dispatchNumber;
            }

        }
        if (!this.selectedData.warehouseName && this.selectedData.inventoryLocationId) {
            this.selectedData.warehouseName = this.warehouseName(this.selectedData.inventoryLocationId)
        }
        this.setRequired(this.selectedData.isPart );
        this.AfterLoad();
    }
    createNewParent(data: InvoiceBus): any {
        return new InvoiceBus(data);
    }

     closeEditor() {
        super.closeEditor();
         this.dataStateChange(null);
         this.setChangeCodeToNull = false;
    }
    clearAllPrices() {
        this.gridData.forEach((e) => {
            e.price = 0;
            e.amount = 0;
            e.isUpdated = true;
        });
        this.sumAggregates(this.gridData)
        this.parentObj.amount = 0;
        this.parentObj.taxAmount = 0;
        this.parentObj.total = 0;
        this.parentObj.saleMaterial = 0;
        this.parentObj.saleLabor = 0;
        this.parentObj.saleOther = 0;
        this.sendParentMessageByMessage(new Message({
            value: this.parentObj,
            messageType: MessageType.pricesCleared
        }));

    }
    public allData(indata: ExcelExportData): ExcelExportData {
        if (!this.exportFilteredData) this.exportFilteredData = [];
        const result: ExcelExportData = {
            data: process(this.gridData as any, {}).data,
        };
        return result;
    }
    printableChangeAll(e: any) {
        console.log("inv-li-pc:", e.target.checked, e);
        let isPrintable = e.target.checked;
        if (this.hasGridData && this.gridData.length > 0) {
            for (let i = 0; i < this.gridData.length; i++) {
                this.gridData[i].isPrintable = isPrintable;
                if (!this.gridData[i].isAdded) {
                    this.gridData[i].isUpdated = true;
                }
            }
            this.SetChanged();
        }
    }
    items: any[] = [
        {
            text: "Item1",
            items: [{ text: "Item1.1" }, { text: "Item1.2" }],
        },
        {
            text: "Item2",
        },
        {
            text: "Item3",
        },
    ];
    partQuantityChanged(qtyTo: number, qtyFrom: number) {
        if (this.referenceData.ARInvoiceCreation === 1 && qtyTo < qtyFrom) {
            this.genericOpenCtrl(true);
            this.invLocDlg_active = true;
        }
    }
    invLocDlg_active: boolean = false;
    invLocDlg_closed(e: ConfirmOutput) {

        if (e.dialogResult === CPDialogResult.ok && CommonFunctions.hasGuidValue(e.data)) {
            this.editForm.patchValue({
                excessInventoryLocationToId: e.data
            });
        }
        else {
            this.editForm.patchValue({
                excessInventoryLocationToId: null,
                quantity: this.editForm.value.originalQuantity
            });
            this.cancelHandler();
        }
        this.closeCtrlOpenFlag = true;
        this.invLocDlg_active = false;
    }
    kpDispatch(e: any) {
        this.setDirty();
        this.fieldNeedsValidation = true;
    }

    public cellClickHandlerX(e: any) {
        console.log("cch: ", e);
        if (e.type !== "contextmenu") {
            this.cellClickHandler(e, false);
        }
        else {
            e.originalEvent.preventDefault();
//            this.menu.show(this.menuEl);
            CommonFunctions.copyToClipboard(e.dataItem.invoiceLineDesc);
            this.notify("Copied: " + e.dataItem.invoiceLineDesc);
        }
    }
    checkBoxChanged(e: any, dataItem, rowIndex, column, columnIndex, setEditMode: boolean = true) {

        if (!this.canEdit) {
            e.target.checked = !e.target.checked;
            return;
        }
        super.checkBoxChanged(e, dataItem, rowIndex, column, columnIndex, setEditMode);
    }
    getNewOrderValue(): number {
        if (this.ARAutomation && !this.isConstruction) {
            this.reOrderNew();
            return 1; // this.getMinOrderValue() - 1;
        }
        else {
            return super.getNewOrderValue();
        }
    }
    protected reOrderNew(): void {
        if (CommonFunctions.hasArrayValue(this.gridData)) {
            for (let i = 0; i < this.gridData.length; i++) {
                this.gridData[i].orderValue = i + 2;
                this.gridData[i].isUpdated = true;
            }
        }
    }

    createTransaction() {
        this.svc_data.createTransaction(this.parentId).subscribe(data => {
            this.notify("Created Successfully");
            this.getAvalaraTaxStatus(this.parentId);
        });
    }

    updateTransaction() {
        var body = {
            invoiceId: this.parentId,
            adjustmentReason: "Other",
            adjustmentDescription: "FJX invoice update"
        }
        this.svc_data.updateTransaction(body).subscribe(data => {
            this.notify("Updated Successfully");
            this.getAvalaraTaxStatus(this.parentId);
        });
    }

    commitTransaction() {
        this.svc_data.commitTransaction(this.parentId).subscribe(data => {
            this.notify("Committed Successfully");
            this.getAvalaraTaxStatus(this.parentId);
        });
    }

    deleteTransaction() {
        this.svc_data.deleteTransaction(this.parentId).subscribe(data => {
            this.notify("Deleted Successfully");
            this.getAvalaraTaxStatus(this.parentId);
        });
    }

    getAvalaraTaxStatus(invoiceId: string){
        this.svc_data.getAvalaraTaxStatus(invoiceId).subscribe((data: any) => {
            if (data !== null) {
                this.avalaraTaxStatus = data.avalaraTaxStatus;
            }
        });
    }
    onChangeSerialNumber(event: any, dataItem: InvoiceLinesBus, rowIndex: number) {
        dataItem.serialNumber = event.srcElement.value;
        dataItem.isUpdated = true;
        this.SetChanged();
    }
    public showOnlyParts(dataItem: any): boolean {
        return dataItem.isPart && dataItem.quantity == 1;
    }
}
